import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface ProductBuyOffsiteClickedProperties {
  user_id: string
  page_url: string
  sellable_id: string
}

export class ProductBuyOffsiteClickedEvent extends Event<ProductBuyOffsiteClickedProperties> {
  static displayName = 'Product Buy Offsite Clicked'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
